import React from 'react';
import { Link, useLocation } from 'react-router-dom';


export default function Navbar({ user, onLogout, onShowUploader, logoUrl }) {
  const { pathname } = useLocation();
  const isAdmin   = user?.role === 'admin';
  const onDashboard = pathname === '/dashboard';

  return (
    <nav className="app-navbar navbar navbar-expand-lg navbar-light bg-light mb-4 px-3">
      <Link className="app-navbar_brand navbar-brand d-flex align-items-center" to="/">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt="Company Logo"
            style={{ height: '30px', marginRight: '8px' }}
            className="app-navbar_logo navbar-logo"
          />
        ) : (
          'FAQ Helper'
        )}
      </Link>

      <div className="app-navbar_controls ms-auto d-flex align-items-center">
        {user ? (
          <>
            <span className="app-navbar_user me-3 user">
              Logged in as <strong>{user.role}</strong>
            </span>

            {isAdmin && (
              <>
                {onDashboard ? (
                  <Link
                    className="app-navbar_nav-btn btn btn-outline-secondary btn-sm me-2"
                    to="/"
                  >
                    FAQs
                  </Link>
                ) : (
                  <Link
                    className="app-navbar_nav-btn btn btn-outline-secondary btn-sm me-2"
                    to="/dashboard"
                  >
                    Dashboard
                  </Link>
                )}
                <button
                  className="app-navbar_upload-btn btn btn-outline-primary btn-sm me-2"
                  onClick={onShowUploader}
                >
                  Upload CSV
                </button>
              </>
            )}

            <button
              className="app-navbar_logout-btn btn btn-outline-danger btn-sm"
              onClick={ async () => {
                try {
                  await onLogout();
                } catch (e) {
                  console.error("Logout failed:", e);
                }
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </>
        ) : (
          <span className="app-navbar_not-logged-in text-muted">Not logged in</span>
        )}
      </div>
    </nav>
  );
}
